import { twMerge } from "tailwind-merge"
import { LogoImage } from "./LogoImage"

// Customers grouped by segment, so a visitor finds teams like their own
export const CUSTOMER_SEGMENTS = [
  {
    label: "Asset managers and ETF issuers",
    logos: [
      "blackrock",
      "grayscale",
      "bitwise",
      "21shares",
      "ark-invest",
      "arca",
      "goldentree-asset-management",
    ],
  },
  {
    label: "Banks, brokers and exchanges",
    logos: [
      "morgan-stanley",
      "standard-chartered",
      "jeffries",
      "falconx",
      "robinhood",
      "binance",
    ],
  },
  {
    label: "Crypto VCs and research",
    logos: [
      "coinbase-ventures",
      "dragonfly",
      "pantera",
      "paradigm",
      "delphi-digital",
      "nansen",
    ],
  },
  {
    label: "Index, data and tech platforms",
    logos: [
      "bloomberg",
      "cf-benchmarks",
      "market-vector",
      "coinmarketcap",
      "the-block",
      "google",
    ],
  },
]

/**
 * Endless logo row. The list renders twice so the -50% loop has no seam.
 * Duration scales with the logo count, so every row moves at the same speed.
 */
export function LogoMarquee({
  logos,
  reverse,
  className,
}: {
  logos: string[]
  reverse?: boolean
  className?: string
}) {
  return (
    <div
      className={twMerge(
        "overflow-hidden [mask-image:linear-gradient(90deg,transparent,black_12%,black_88%,transparent)]",
        className
      )}
    >
      <div
        className={twMerge(
          "flex w-max animate-marquee hover:[animation-play-state:paused] motion-reduce:animate-none",
          reverse && "[animation-direction:reverse]"
        )}
        style={{ animationDuration: `${logos.length * 7}s` }}
      >
        {[...logos, ...logos].map((id, i) => (
          <LogoImage
            key={`${id}-${i}`}
            logoId={id}
            alt={id}
            aria-hidden={i >= logos.length}
            width={250}
            height={100}
            className="w-40 -mx-4 md:w-44 md:mx-0 h-auto shrink-0 object-contain"
          />
        ))}
      </div>
    </div>
  )
}
